// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p8-0";
export var animationContainer = "_p8-1";
export var itemPrice = "_p8-a";
export var itemizedContent = "_p8-9";
export var itemizedHeader = "_p8-7";
export var itemizedRow = "_p8-8";
export var itemizedSection = "_p8-6";
export var modalContent = "_p8-2";
export var orderName = "_p8-3";
export var refundOption = "_p8-4";
export var refundOptionsContainer = "_p8-5";
export var shippingLabel = "_p8-b";
export var totalRow = "_p8-c";